import Dashboard from './Dashboard';
import './Dashboard.scss';

export default Dashboard;
